<template>
  <div class="cont-throughput-main">
    <div class="left-container">
      <div class="date-refresh-section">
        <div class="from-to-date">
          <DateTimePicker title="From" :showTime="false" :value.sync="selectedFromDate" :errorMessage.sync="fromDateError" />
          <DateTimePicker title="To" :showTime="false" :value.sync="selectedToDate" :errorMessage.sync="toDateError" />
        </div>
        <button @click="refreshClicked">Refresh</button>
      </div>

      <Dropdown style="margin: 10px 0" placeholder="System" :items="systemItems" itemKey="Application Name" :selectedObject.sync="selectedSystem"
        :errorMessage.sync="systemError" />

      <Filters class="customer-filter" title="Customer" :tableData="customerData" itemKey="Customer Code" itemDesc="Customer Name"
        @confirmClicked="filterConfirm" />

      <Tabulator class="table-details" :tableData="tableDetails" multiSelect="1" @rowSelected="tableRowSelected" ref="leftTable" />
      <!-- <TableBox class="table-details" :tableData="tableDetails" :selectedRow.sync="selectedContainers" :maxSelection="-1" /> -->
    </div>

    <div class="right-container">
      <div class="filtered-section">
        <div class="filtered-items">
          <div class="filtered-row">
            <div class="filter-title">Job Date</div>
            <div class="colon-separator">:</div>
            <div class="filter-details" :title="`${filteredFromDate} to ${filteredToDate}`" v-if="filteredFromDate">{{ filteredFromDate }} to {{ filteredToDate }}</div>
          </div>
          <div class="filtered-row">
            <div class="filter-title">System</div>
            <div class="colon-separator">:</div>
            <div class="filter-details" :title="filteredSystem.System ? filteredSystem.System : ''">{{ filteredSystem.System ? filteredSystem.System : '' }}</div>
          </div>
          <div class="filtered-row">
            <div class="filter-title">Customer</div>
            <div class="colon-separator">:</div>
            <div class="filter-details" :title="filteredCustomer.length == 0 ? 'All' : filteredCustomer.map((s) => { return s['Customer Code'] }).join(', ')">{{ filteredCustomer.length == 0 ? 'All' : filteredCustomer.map((s) => { return s['Customer Code'] }).join(',') }}</div>
          </div>
        </div>
        <div class="refresh-section">
          <div v-if="lastRefresh">Last Refreshed : {{ lastRefresh }}</div>
        </div>
      </div>

      <div class="map-section">
        <div class="pol-section">
          <div class="map-title">Container Throughput by POL Country (Import)</div>
          <div class="hover-details" v-if="polHoverObject || selectedPol" style="margin-right: 3px">
            <div class="title">{{ polHoverObject ? polHoverObject['country'] : selectedPol['country'] }}</div>
            <table>
              <tr><th> TEUs Percentage </th> <td>: {{ polHoverObject ? polHoverObject['TEUPerc'].toFixed(2) : selectedPol['TEUPerc'].toFixed(2) }}%</td></tr>
              <tr><th> Total TEUs </th> <td>: {{ polHoverObject ? polHoverObject['totalTEUs'] : selectedPol['totalTEUs'] }}</td></tr>
              <tr><th> Total 20s </th> <td>: {{ polHoverObject ? polHoverObject['total20s'] : selectedPol['total20s'] }}</td></tr>
              <tr><th> Total 40s </th> <td>: {{ polHoverObject ? polHoverObject['total40s'] : selectedPol['total40s'] }}</td></tr>
            </table>
          </div>
          <div v-if="polZoom" class="zoom-loading">Loading</div>
          <div id="polMap"></div>
        </div>

        <div class="pod-section">
          <div class="map-title">Container Throughput by POD Country (Export)</div>
          <div class="hover-details" v-if="podHoverObject || selectedPod">
            <div class="title">{{ podHoverObject ? podHoverObject['country'] : selectedPod['country'] }}</div>
            <table>
              <tr><th> TEUs Percentage </th> <td>: {{ podHoverObject ? podHoverObject['TEUPerc'].toFixed(2) : selectedPod['TEUPerc'].toFixed(2) }}%</td></tr>
              <tr><th> Total TEUs </th> <td>: {{ podHoverObject ? podHoverObject['totalTEUs'] : selectedPod['totalTEUs'] }}</td></tr>
              <tr><th> Total 20s </th> <td>: {{ podHoverObject ? podHoverObject['total20s'] : selectedPod['total20s'] }}</td></tr>
              <tr><th> Total 40s </th> <td>: {{ podHoverObject ? podHoverObject['total40s'] : selectedPod['total40s'] }}</td></tr>
            </table>
          </div>
          <div v-if="podZoom" class="zoom-loading">Loading</div>
          <div id="podMap"></div>
        </div>
      </div>

      <div class="chart-section">
        <div class="pol-chart">
          <img v-if="selectedPol" class="chart-icon" src="https://dsmapi.logistics.systems/dsm6gicons/clickable.png" title="Click on bar to view jobs by port"/>
          <div v-if="!selectedPol" class="empty-chart">No country selected for POL<br />Click on a country in the map above to view the details</div>
          <div id="polChart"></div>
        </div>
        <div class="pod-chart">
          <img v-if="selectedPod" class="chart-icon" src="https://dsmapi.logistics.systems/dsm6gicons/clickable.png" title="Click on bar to view jobs by port"/>
          <div v-if="!selectedPod" class="empty-chart">No country selected for POD<br />Click on a country in the map above to view the details</div>
          <div id="podChart"></div>
        </div>
      </div>
    </div>

    <ContextMenu v-if="showContextMenu" :show.sync="showContextMenu" :position="contextPosition" :contextItems="contextItems"
      @contextSelected="contextSelected" ref="context"/>

    <Loader :isVisible.sync="loading" :loadingText="loadText" />
  </div>
</template>

<script>
/* eslint-disable */
import DateTimePicker from '@/components/DateTimePicker.vue';
import Dropdown from '@/components/Dropdown.vue';
import Filters from '@/components/Filters.vue';
import Loader from '@/components/Loader.vue';
import Tabulator from '@/components/Tabulator.vue';
import ContextMenu from '@/components/ContextMenu.vue';

export default {
  components: {
    DateTimePicker, Dropdown, Filters, Loader, Tabulator, ContextMenu
  },
  data: function() {
    return {
      currentPODCountry: null,
      currentPOLCountry: null,

      allCountries: [],
    }
  },
  props: {
    systemItems: { type: Array, default: function() { return [] } },
    customerData: { type: Array, default: function() { return [] } },

    selectedSystem: { type: Object, default: function() { return null } },
    filteredSystem: { type: Object, default: function() { return {} } },

    selectedToDate: { type: Date, default: null },
    selectedFromDate: { type: Date, default: null },
    filteredToDate: { type: Date, default: null },
    filteredFromDate: { type: Date, default: null },

    loading: { type: Boolean, default: false },
    loadText: { type: String, default: '' },

    selectedCustomer: { type: Array, default: function() { return [] } },
    filteredCustomer: { type: Array, default: function() { return [] } },

    lastRefresh: { type: String, default: '' },

    toDateError: { type: String, default: '' },
    fromDateError: { type: String, default: '' },
    systemError: { type: String, default: '' },

    podHoverObject: { type: Object, default: function() { return null } },
    polHoverObject: { type: Object, default: function() { return null } },
    selectedPod: { type: Object, default: function() { return null } },
    selectedPol: { type: Object, default: function() { return null } },

    tableDetails: { type: Array, default: function() { return [] } },

    // For Context Menu
    showContextMenu: { type: Boolean, default: false },
    contextItems: { type: Array, default: function() { return [ 'POD TEUs jobs for [PORT]' ] } },
    contextPosition: { type: Array, default: function() { return [ 100, 100 ] } },

    // For world map
    podMap: { type: Object, default: function() { return {} } },
    polMap: { type: Object, default: function() { return {} } },

    mapOptions: { type: Object, default: function() { return {
      attributionControl: false,
      // zoomAnimation: false
    } } },

    polTitle: { type: String, default: '' },
    podTitle: { type: String, default: '' },
    mapGeoJson: { type: Object, default: function() { return {} } },
    podGeoJson: { type: Object, default: function() { return null } },
    polGeoJson: { type: Object, default: function() { return null } },
    selectedPolMap: { type: Object, default: function() { return null } },
    selectedPodMap: { type: Object, default: function() { return null } },

    allPOLLayers: { type: Object, default: function() { return null } },
    allPODLayers: { type: Object, default: function() { return null } },

    polZoom: { type: Boolean, default: false },
    podZoom: { type: Boolean, default: false },
  },
  methods: {
    filterConfirm: function(items) {
      this.selectedCustomer = items;
    },
    refreshClicked: async function() {
      if (!this.checkError()) {
        return;
      }

      $('#polChart').html('');
      $('#podChart').html('');

      this.filteredToDate = this.$dateTime.getDateTime(this.selectedToDate, 'yyyy-MM-dd');
      this.filteredFromDate = this.$dateTime.getDateTime(this.selectedFromDate, 'yyyy-MM-dd');
      this.filteredSystem = this.selectedSystem
      this.filteredCustomer = this.selectedCustomer;
      this.lastRefresh = this.$dateTime.getDateTime(new Date(), 'dd/MM/yyyy HH:mm');

      var dataToPost = {
         'startdate': this.filteredFromDate,
         'enddate': this.filteredToDate,
         'rpttype': '',
         'system': this.filteredSystem.System ? this.filteredSystem.System.trim() : '',
         'jobtype': '',
         'customerarray': this.filteredCustomer.length == 0 ? '' : this.filteredCustomer.map((c) => { return c['Customer Code'] }).join(',')
      }

      this.loading = true;

      this.loadText = 'Getting POL';
      dataToPost.rpttype = 'BY_POL';
      var POL = await this.$apiCallV2('/ContainerThroughputPOLPOD/GetContAnalysis', dataToPost);

      this.polGeoJson = {
        type: 'FeatureCollection',
        features: this.createGeoJson(POL, 'POL')
      };
      this.loadPOLMap();
      
      this.$nextTick(async() => {
        this.loadText = 'Getting POD';
        dataToPost.rpttype = 'BY_POD';
        var POD = await this.$apiCallV2('/ContainerThroughputPOLPOD/GetContAnalysis', dataToPost);
        
        this.podGeoJson = {
          type: 'FeatureCollection',
          features: this.createGeoJson(POD, 'POD')
        };
        this.loadPODMap();

        this.$nextTick(() => {
          this.loading = false;
        })
      });
    },
    checkError: function() {
      var errorCount = 0;

      if (!this.selectedFromDate) {
        errorCount++;
        this.fromDateError = 'Date is required!';
      }

      if (!this.selectedToDate) {
        errorCount++;
        this.toDateError = 'Date is required!';
      }

      if (!this.selectedSystem) {
        errorCount++;
        this.systemError = 'System is required!';
      }

      return errorCount == 0;
    },
    // Map functions
    loadPODMap: function() {
      document.getElementById('podMap').outerHTML = '<div id="podMap" class="map-style"></div>';
      this.podMap = L.map('podMap', this.mapOptions).setView([0,0], 1);

      L.tileLayer(
        'https://api.maptiler.com/maps/voyager/{z}/{x}/{y}.png?key=bXzh6APCqEBOILcI2X7G'
      ).addTo(this.podMap);

      this.mapGeoJson = L.geoJson(this.podGeoJson, {
        style: this.mapStyling,
        onEachFeature: this.mapFeatures
      }).addTo(this.podMap);

      this.podMap.on('zoomstart', () => {
        if (!this.podZoom) {
          this.podZoom = true;
        }
      });
      this.podMap.on('zoomend', () => { this.podZoom = false });

      this.podMap.eachLayer((l) => {
        if (l instanceof L.TileLayer) {
          if (l._map._renderer) {
            this.allPODLayers = l._map._renderer._layers;
          }
        }
      });
    },
    loadPOLMap: function() {
      document.getElementById('polMap').outerHTML = '<div id="polMap" class="map-style"></div>';
      this.polMap = L.map('polMap', this.mapOptions).setView([0,0], 1);

      L.tileLayer(
        'https://api.maptiler.com/maps/voyager/{z}/{x}/{y}.png?key=bXzh6APCqEBOILcI2X7G'
      ).addTo(this.polMap);

      this.mapGeoJson = L.geoJson(this.polGeoJson, {
        style: this.mapStyling,
        onEachFeature: this.mapFeatures
      }).addTo(this.polMap);
      
      this.polMap.on('zoomstart', () => {
        if (!this.polZoom) {
          this.polZoom = true;
        }
      });
      this.polMap.on('zoomend', () => { this.polZoom = false });
      
      this.polMap.eachLayer((l) => {
        if (l instanceof L.TileLayer) {
          if (l._map._renderer) {
            this.allPOLLayers = l._map._renderer._layers;
          }
        }
      });
    },
    mapStyling: function(f) {
      // var opac = Math.ceil((f.properties['TEUPerc'] / 100).toFixed(2) * 10) / 10;
      var opac = (f.properties.opac.toFixed(2) / 100).toFixed(2);
      return {
        fillColor: `rgba(185, 119, 14, ${opac <= 0.15 ? 0.15 : opac})`,
        weight: 1,
        opacity: 1,
        color: 'transparent',
        fillOpacity: 1
      }
    },
    mapFeatures: function(feature, layer) {
      layer.on({
        mouseover: this.countryMouseIn,
        mouseout: this.countryMouseOut,
        click: this.countryClicked
      });
    },
    countryMouseIn: function(e) {
      var layer = e.target;

      if (layer.options.color == 'blue') {
        return;
      }

      layer.setStyle({
        weight: 1,
        color: 'black'
      });
      
      if (layer.feature.properties.rptType == 'POL') {
        this.polHoverObject = layer.feature.properties;
      } else {
        this.podHoverObject = layer.feature.properties;
      }

      if (!L.Browser.ie && !L.Browser.opera && !L.Browser.edge) {
        layer.bringToFront();
      }
    },
    countryMouseOut: function(e) {
      if (e.target.options.color == 'black') {
        this.mapGeoJson.resetStyle(e.target);
      }

      this.polHoverObject = null;
      this.podHoverObject = null;
    },
    countryClicked: function(e, fromTable) {
      var layer = e.target;
      var countryDetails = e.target.feature.properties;

      if (layer.options.color == 'blue') {
        this.mapGeoJson.resetStyle(layer);

        if (countryDetails.rptType == 'POL') {
          this.currentPOLCountry = null;
          this.polMap.closePopup();
          this.selectedPol = null;
          this.selectedPolMap = null;
          this.polMap.setView([0, 0], 1);
          $('#polChart').html('');
        } else {
          this.currentPODCountry = null;
          this.podMap.closePopup();
          this.selectedPod = null;
          this.selectedPodMap = null;
          this.podMap.setView([0, 0], 1);
          $('#podChart').html('');
        }

        if (!this.currentPOLCountry && !this.currentPODCountry) {
          this.$refs['leftTable'].clearAllSelectedRow();
        }

        return;
      }

      layer.setStyle({
        weight: 1,
        color: 'blue'
      });

      if (countryDetails.rptType == 'POL') {
        this.currentPOLCountry = e;
        this.polMap.closePopup();
        if (this.selectedPolMap) {
          this.mapGeoJson.resetStyle(this.selectedPolMap);
        }
        this.polMap.fitBounds(layer.getBounds());
        this.selectedPol = countryDetails;
        this.selectedPolMap = e.target;
        this.createBarChart('#polChart', `Total TEUs by POL in ${countryDetails.country}`, countryDetails.details);

        var lPopup = L.popup({ closeOnClick: false, autoClose: false, closeButton: false });
        var popupContent = `<p class="pol-drill-through">POL TEUs summary<br />by customer for ${countryDetails.country}
        </p><img class="popup-icon" src="https://dsmapi.logistics.systems/dsm6gicons/open-in-new-tab.png" title="View container job summary"/>`;

        if (e.latlng) {
          lPopup.setLatLng([e.latlng.lat, e.latlng.lng]).setContent(popupContent).openOn(this.polMap);
        } else {
          var center = layer.getBounds().getCenter();
          lPopup.setLatLng([center.lat, center.lng]).setContent(popupContent).openOn(this.polMap);
        }

        var polDrillThrough = $('.pol-drill-through');
        polDrillThrough.click(() => { this.drillThroughClicked('BY_POL_CSGN', countryDetails) });
      } else {
        this.currentPODCountry = e;
        this.podMap.closePopup();
        if (this.selectedPodMap) {
          this.mapGeoJson.resetStyle(this.selectedPodMap);
        }
        this.podMap.fitBounds(layer.getBounds());
        this.selectedPod = countryDetails;
        this.selectedPodMap = e.target;
        this.createBarChart('#podChart', `Total TEUs by POD in ${countryDetails.country}`, countryDetails.details);

        var lPopup = L.popup({ closeOnClick: false, autoClose: false, closeButton: false });
        var popupContent = `<p class="pod-drill-through">POD TEUs summary<br />by customer for ${countryDetails.country}
        </p><img class="popup-icon" src="https://dsmapi.logistics.systems/dsm6gicons/open-in-new-tab.png" title="View container job summary"/>`;

        if (e.latlng) {
          lPopup.setLatLng([e.latlng.lat, e.latlng.lng]).setContent(popupContent).openOn(this.podMap);
        } else {
          var center = layer.getBounds().getCenter();
          lPopup.setLatLng([center.lat, center.lng]).setContent(popupContent).openOn(this.podMap);
        }

        var podDrillThrough = $('.pod-drill-through');
        podDrillThrough.click(() => { this.drillThroughClicked('BY_POD_SHPR', countryDetails) });
      }
    },
    drillThroughClicked: async function(rptType, country, port) {
      this.loadText = `Getting details`;
      this.loading = true;
      
      var dataToPost = {
        'startdate': this.filteredFromDate,
        'enddate': this.filteredToDate,
        'rpttype': rptType,
        'system': this.filteredSystem.System ? this.filteredSystem.System.trim() : '',
        'jobtype': '',
        'customerarray': this.filteredCustomer.length == 0 ? '' : this.filteredCustomer.map((c) => { return c['Customer Code'] }).join(',')
      }

      if (country) {
        var countryName = country.country;
        var countryCode = country.details[0]['XAxis'];

        var drillThrough = await this.$apiCallV2('/ContainerThroughputPOLPOD/GetContAnalysis', dataToPost);

        var drillThroughSelectedCountry = drillThrough.filter((d) => { return d['Country Code'] == countryCode });

        sessionStorage.setItem(`Drill Through - ${rptType == 'BY_POL_CSGN' ? 'POL' : 'POD'} ${countryCode}`, JSON.stringify({ country: countryName, data: drillThroughSelectedCountry }));

        var drillThroughLink = this.$router.resolve(`/Home/${this.$route.params['user']}/Dashboard/Container Throughput POL and POD/Drill Through - ${rptType == 'BY_POL_CSGN' ? 'POL' : 'POD'} ${countryCode}`);
        window.open(drillThroughLink.href, '_blank');
      }

      if (port) {
        var drillThrough = await this.$apiCallV2('/ContainerThroughputPOLPOD/GetContAnalysis', dataToPost);

        var selectedPort = drillThrough.filter((d) => { return d['Port Code'] == port });

        sessionStorage.setItem(`Drill Through - ${rptType == 'BY_POL_JOB' ? 'POL' : 'POD'} ${port}`, JSON.stringify({ country: '', data: selectedPort, port: port }));

        var drillThroughLink = this.$router.resolve(`/Home/${this.$route.params['user']}/Dashboard/Container Throughput POL and POD/Drill Through - ${rptType == 'BY_POL_JOB' ? 'POL' : 'POD'} ${port}`);
        window.open(drillThroughLink.href, '_blank');
      }

      this.loading = false;
    },
    createGeoJson: function(data, type) {
      var uniqueCountry = [...new Set(data.map((p) => { return p.XAxis }))];
      uniqueCountry = uniqueCountry.filter((u) => { return u }); // Removing all countries which is null or empty
      data = data.filter((d) => { return d.XAxis }); // Removing all null or empty string from XAxis
      var features = [];
      
      uniqueCountry.forEach((u) => {
        var json = this.allCountries.features.filter((f) => { return f.properties['ISO_A3'].toUpperCase().trim() == u.toUpperCase().trim() });
        if (json.length > 0) {
          var allDetails = data.filter((d) => { return d.XAxis.toUpperCase() == u.toUpperCase() });
          var properties = {
            country: allDetails[0]['Country_Name'],
            TEUPerc: allDetails.map((a) => { return a.TEUPerc }).reduce((a, b) => { return a + b }),
            totalTEUs: allDetails.map((a) => { return a.TEUs }).reduce((a, b) => { return a + b }),
            total20s: allDetails.map((a) => { return a.Total20 }).reduce((a, b) => { return a + b }),
            total40s: allDetails.map((a) => { return a.Total40 }).reduce((a, b) => { return a + b }),
            details: allDetails,
            rptType: type
          };
          
          features.push({ type: 'Feature', properties: properties, geometry: json[0].geometry });
        } else {
          var noDetails = data.filter((d) => { return d.XAxis.toUpperCase() == u.toUpperCase() });
          console.log(`Cannot find ${u} - ${JSON.stringify(noDetails)}`);
        }
      });
      
      var max = Math.max.apply(Math, features.map((f) => { return f.properties['TEUPerc'] }));
      var toHundredPercent = 100 / max.toFixed(2);

      features.forEach((f) => { f.properties.opac = f.properties['TEUPerc'] * toHundredPercent });

      var finalFeatures = features.filter((f) => { return f });

      if (type == 'POL') {
        this.tableDetails = [];
        
        finalFeatures.forEach((f) => {
          this.tableDetails.push({ '#': '', Country: f.properties.country.trim(), 'POL %': f.properties.TEUPerc.toFixed(2), 'POD %': '' })
        });
      } else {
        finalFeatures.forEach((f) => {
          var countryExists = this.tableDetails.filter((t) => { return t.Country == f.properties.country.trim() });
          if (countryExists.length > 0) {
            countryExists[0]['POD %'] = f.properties.TEUPerc.toFixed(2);
          } else {
            this.tableDetails.push({ '#': '', Country: f.properties.country.trim(), 'POL %': '', 'POD %': f.properties.TEUPerc.toFixed(2) });
          }
        });

        this.tableDetails.sort((a, b) => { return a.Country > b.Country ? 1 : -1 });

        var index = 1;
        this.tableDetails.forEach((t) => { t['#'] = index++ });
        this.tableDetails.splice(0, 0, { '#': '0', Country: 'String', 'POL %': 'Number', 'POD %': 'Number' });
      }
      
      return finalFeatures;
    },
    tableRowSelected: function(row) {
      if (row == null) {
        if (this.currentPODCountry) {
          this.countryClicked(this.currentPODCountry);
        } 
        if (this.currentPOLCountry) {
          this.countryClicked(this.currentPOLCountry);
        }
        return;
      }

      if (row['POL %']) {
        var polLayer = Object.keys(this.allPOLLayers).filter((l) => { return this.allPOLLayers[l].feature.properties.country.trim() == row.Country });
        var countryObject = { target: this.allPOLLayers[polLayer[0]] };
        this.countryClicked(countryObject, true);
      } else if (this.currentPOLCountry) {
        this.countryClicked(this.currentPOLCountry, true);
      }

      if (row['POD %']) {
        var podLayer = Object.keys(this.allPODLayers).filter((l) => { return this.allPODLayers[l].feature.properties.country.trim() == row.Country });
        var countryObject = { target: this.allPODLayers[podLayer[0]] };
        this.countryClicked(countryObject, true);
      } else if (this.currentPODCountry) {
        this.countryClicked(this.currentPODCountry, true);
      }
    },
    // Bar chart method
    createBarChart: function(id, title, data) {
      $(id).html('');

      var ctBarID = id == '#polChart' ? 'isPOL' : 'isPOD';
      
      var options = {
        axisY: {
          onlyInteger: true
        },
        classNames: {
          bar: `ct-bar ${ctBarID}`
        }
      };

      var barChart = new Chartist.Bar(id, {
        labels: data.map((d) => { return d['XAxisDesc'] }),
        series: [
          data.map((d) => { return { meta: `TEUs|${d['XAxisDesc']}|${d['Port_Name']}`, value: d['TEUs'] } })
        ]
      }, options);

      var title = $(`<div class="chart-title">${title}</div>`).appendTo($(id));
      var $tooltip = $(`<div class="tooltip tooltip-hidden"></div>`).appendTo($(id));

      barChart.on('created', () => {
        $('.ct-series-a').children('.ct-bar').addClass('bar-20-color');
        $('.ct-series-b').children('.ct-bar').addClass('bar-40-color');

        $('.ct-label').css({ color: 'black' });
        $('.ct-horizontal').css({
          transform: 'translate(calc(-50% - 5px)) rotate(-90deg)',
          fontSize: '9px',
          justifyContent: 'flex-end',
          transformOrigin: '100% 0'
        });

        $(`.${ctBarID}`).on('mouseover', function() {
          var meta = $(this).attr('ct:meta');
          $tooltip.html(`<span>${meta.split('|')[1]}</span><br /><span>${meta.split('|')[2]}</span><br /><br /><span>${meta.split('|')[0]}: ${$(this).attr('ct:value')}</span>`);
          $tooltip.removeClass('tooltip-hidden');
        });

        $(`.${ctBarID}`).on('mouseout', function() {
          $tooltip.addClass('tooltip-hidden');
        });

        $(`.${ctBarID}`).on('mousemove', function(e) {
          $tooltip.css({
            left: e.offsetX,
            top: e.offsetY - 20
          });
        });

        var mainContainer = this;

        $(`.${ctBarID}`).on('click', function(e) {
          var meta = $(this).attr('ct:meta');
          mainContainer.showContextMenu = true;

          var portName = meta.split('|');
          var selectedCountry = ctBarID == 'isPOL' ? mainContainer.selectedPol : mainContainer.selectedPod;
          
          mainContainer.contextItems = [ `${ctBarID == 'isPOL' ? 'POL' : 'POD'} TEUs jobs for ${portName[1]} (${selectedCountry.country.trim()})` ];
          
          mainContainer.$nextTick(() => {
            mainContainer.contextPosition = [ e.clientY - (mainContainer.$refs.context.$el.clientHeight + 50), e.clientX - 150 ];
          });
        });
      });
    },
    // Context Menu method
    contextSelected: function(item) {
      this.drillThroughClicked(item.includes('POL') ? 'BY_POL_JOB' : 'BY_POD_JOB', null, item.split(' ')[4]);
    }
  },
  async mounted() {    
    this.loading = true;

    this.loadText = 'Getting Systems';
    this.systemItems = await this.$apiCallV2('/ContainerThroughputPOLPOD/GetListMaster?master=SYSTEM');   

    this.loadText = 'Getting Customers';
    this.customerData = await this.$apiCallV2('/ContainerThroughputPOLPOD/GetListMaster?master=BILLCUSTNAME');

    this.loadText = 'Getting World Geo';
    this.allCountries = await this.$apiCallV2('/ContainerThroughputPOLPOD/GetWorldGeoJson');

    var year = new Date().getFullYear();
    var month = new Date().getMonth();
    var lastDate = new Date(year, month + 1, 0).getDate();

    this.selectedFromDate = new Date(year, month, 1);
    this.selectedToDate = new Date(year, month, lastDate);
    this.selectedSystem = this.systemItems[0];

    this.loading = false;

    this.refreshClicked();
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.cont-throughput-main {
  display: flex;
  padding: 5px 45px;
  font-size: 12px;

  > .left-container {
    height: 100%;
    min-width: 250px;
    max-width: 300px;
    padding: 5px;
    background-color: white;
    // border: 1px solid rgb(200,200,200);
    border-radius: 5px;
    margin-right: 5px;

    > .date-refresh-section {
      display: flex;
      align-items: center;

      > .from-to-date {
        flex-grow: 1;
      }

      > button {
        height: fit-content;
      }
    }

    > .customer-filter {
      height: calc(100% - 390px);
    }

    > .table-details {
      height: 250px;
    }
  }

  > .right-container {
    width: calc(100% - 250px);
    height: 100%;
    display: flex;
    flex-direction: column;

    > .filtered-section {
      width: 100%;  
      background-color: white;
      border-radius: 5px;
      padding: 5px;
      position: relative;
      display: flex;
      align-items: center;

      > .filtered-items {
        width: calc(100% - 250px);

        > .filtered-row {
          display: flex;
          align-items: center;

          > .filter-title {
            width: 70px;
          }

          > .colon-separator {
            margin: 0 5px;
          }

          > .filter-details {
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
      
      > .refresh-section {
        height: 100%;
        min-width: 250px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-end;

        > button {
          width: fit-content;
          margin: 3px 0;
        }
      }
    }

    > .map-section {
      margin-top: 5px;
      display: flex;
      height: calc(100% + 200px);
      width: 100%;

      > .pod-section, > .pol-section {
        width: 50%;
        height: 100%;
        position: relative;
        background-color: white;
        border-radius: 5px;
        overflow: hidden;

        > .map-title {
          font-weight: bold;
          text-align: center;
          width: 100%;
          height: 20px;
        }

        > .zoom-loading {
          position: absolute;
          z-index: 1001;
          background-color: rgba(0,0,0,0.3);
          color: white;
          height: calc(100% - 20px);
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        > .hover-details {
          background-color: white;
          display: flex;
          flex-direction: column;
          width: fit-content;
          position: absolute;
          top: 23px;
          right: 3px;
          padding: 5px;
          border-radius: 3px;
          border: 1px solid rgb(200,200,200);
          z-index: 600;

          > .title {
            font-weight: bold;
            text-align: center;
          }
        }
      }

      > .pol-section {
        margin-right: 3px;
      }

      > .pod-section {
        margin-left: 3px;
      }
    }

    > .chart-section {
      height: 50%;
      width: 100%;
      display: flex;
      margin-top: 5px;

      > .pol-chart, > .pod-chart {
        width: 50%;
        height: 100%;
        position: relative;
        background-color: white;
        border-radius: 5px;

        > .empty-chart {
          position: absolute;
          height: 100%;
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          font-weight: bolder;
          font-size: 10px;
          text-align: center;
        }
      }

      > .pol-chart {
        margin-right: 3px;
      }

      > .pod-chart {
        margin-left: 3px;
      }
    }
  }
}
</style>

<style lang="scss">

img.chart-icon{
  width: 25px;
  height: 25px;
  position:  absolute;
  top: 15px;
  right: 7px;
  z-index: 600;
}

img.popup-icon{
  width: 20px;
  height: 20px;
  position:  absolute;
  top: 4px;
  right: 7px;
}

.bar-20-color {
  stroke: blue !important;
}

.bar-40-color {
  stroke: aqua !important;
}

.map-style {
  width: 100%;
  height: calc(100% - 20px);
}

.chart-title {
  // position: absolute;
  // top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 25px;
  text-align: center;
  font-weight: bold;
}

.pol-drill-through, .pod-drill-through {
  font-weight: bold;
  cursor: pointer;
  text-align: center;
}

.leaflet-popup-content-wrapper, .leaflet-popup-tip {
  background-color: #383838;
  color: white;
}
</style>